export type Responsibility = 'user' | 'server'

export type MinimalAppError = {
  httpStatus?: number
  responsibility?: Responsibility
  details?: {
    messages?: string[]
    fieldErrors?: Record<string, string[]>
  }
  message?: string
  status?: number // some clients attach status here
}

export function isServerError(err: unknown): boolean {
  const e = err as MinimalAppError | undefined
  if (e?.responsibility) return e.responsibility === 'server'
  const status = e?.httpStatus ?? e?.status
  if (typeof status === 'number') return status >= 500
  // Default conservative: treat unknown as server error
  return true
}

export function extractUserMessages(err: unknown): string[] {
  const e = err as MinimalAppError | undefined
  const msgs: string[] = []
  if (e?.details?.messages && e.details.messages.length > 0) {
    msgs.push(...e.details.messages)
  }
  if (e?.details?.fieldErrors) {
    for (const arr of Object.values(e.details.fieldErrors)) {
      if (Array.isArray(arr)) {
        msgs.push(...arr)
      }
    }
  }
  if (msgs.length === 0 && e?.message) msgs.push(e.message)
  if (msgs.length === 0) msgs.push('Bitte Eingaben prüfen')
  return msgs
}
